/* eslint-disable react/no-array-index-key */
import React from 'react';

export const replaceStringWithComponents = (
    text: string,
    components: JSX.Element | JSX.Element[],
    searchString = '%s'
): string | JSX.Element => {
    const componentsArr = Array.isArray(components) ? components : [components];
    const splitText = text.split(searchString);

    if (splitText.length === 1) {
        return text;
    }

    const content = splitText.reduce(
        (acc, current, index) =>
            index !== splitText.length - 1
                ? [...acc, current, React.cloneElement(componentsArr[index], { key: `${text}_${index}` })]
                : [...acc, current],
        []
    );

    return <>{content}</>;
};
